export enum TrainingAssignmentTypeEnum {
  MyAssignments = 'myAssignments',
  MyTeamsAssignments = 'myTeamsAssignments',
  CompanyAssignments = 'companyAssignments',
  ILCAssignments = 'ilcAssignments',
  OverdueAssignment = 'overdueAssignments',
}
